<template>
  <job-preview-content-data-outline
    :update-date="environment.updateDate"
    class="pt25 pb25 plr20 mt15 -company"
  >
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="environment-company"
      :comment-highlights="commentHighlights"
      v-on="$listeners"
    />

    <div class="data-area pt20 pb20">
      <job-preview-content-pie-data
        :target-id="`${targetIdMap.environment.woman}${targetIdMap.environment.company.suffix}`"
        title="女性社員の割合"
        :value="environment.womanRate"
        data-test="woman"
        v-on="$listeners"
      />

      <job-preview-content-pie-data
        :target-id="`${targetIdMap.environment.officer}${targetIdMap.environment.company.suffix}`"
        title="女性役員・管理職の割合"
        :value="environment.officerRate"
        class="pacentage-manage"
        data-test="officer"
        v-on="$listeners"
      />

      <job-preview-content-bar-data
        :target-id="`${targetIdMap.environment.overtime}${targetIdMap.environment.company.suffix}`"
        title="残業時間（平均）"
        :value="environment.overtime"
        :average-value="average.environment.overtime"
        unit="時間"
        data-test="overtime"
        v-on="$listeners"
      />

      <job-preview-content-bar-data
        :target-id="`${targetIdMap.environment.pto}${targetIdMap.environment.company.suffix}`"
        title="有給取得率"
        :value="environment.ptoRate"
        :average-value="average.environment.pto"
        unit="%"
        data-test="pto"
        v-on="$listeners"
      />

      <job-preview-content-bar-data
        :target-id="`${targetIdMap.environment.maternity}${targetIdMap.environment.company.suffix}`"
        title="育休取得率"
        :value="environment.maternityRate"
        :average-value="average.environment.maternity"
        unit="%"
        data-test="maternity"
        v-on="$listeners"
      />

      <job-preview-content-bar-data
        :target-id="`${targetIdMap.environment.lengthService}${targetIdMap.environment.company.suffix}`"
        title="女性社員の平均勤続年数"
        :value="environment.lengthService"
        :average-value="average.environment.lengthService"
        unit="年"
        class="average-lengthofservice"
        data-test="lengthService"
        v-on="$listeners"
      />

      <section
        v-if="certificateCount"
        class="data certificate mb10"
        :class="{'low-case' : isCertificatePositionRight}"
        data-test="certificate"
      >
        <div :id="`${targetIdMap.environment.certification}${targetIdMap.environment.company.suffix}`">
          <p class="h-style-02">
            国認定
          </p>
          <job-preview-content-data-tooltip />
          <ul class="mt20">
            <li :class="environment.isKurumin ? 'on':''">
              くるみん
            </li>
            <li :class="environment.isPlatinumKurumin ? 'on':''">
              プラチナくるみん
            </li>
            <li :class="environment.isNadeshiko ? 'on':''">
              なでしこ銘柄
            </li>
            <li :class="environment.isEruboshi ? 'on':''">
              えるぼし
            </li>
          </ul>
        </div>
      </section>

      <section
        v-if="environment.womanAction"
        class="data other"
        :class="[{'short-case':isWomanActionPositionTop}, {'low-case':isWomanActionPositionRight}]"
        data-test="action"
      >
        <div :id="`${targetIdMap.environment.action}${targetIdMap.environment.company.suffix}`">
          <p class="h-style-02">
            その他の取り組み
          </p>
          <p
            class="mt10 pega-pre-wrap"
            v-text="environment.womanAction"
          />
        </div>
      </section>
    </div>
  </job-preview-content-data-outline>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContentDataOutline from '@/components/atoms/JobPreviewContentDataOutline'
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import JobPreviewContentPieData from '@/components/atoms/JobPreviewContentPieData'
import JobPreviewContentBarData from '@/components/atoms/JobPreviewContentBarData'
import JobPreviewContentDataTooltip from '@/components/atoms/JobPreviewContentDataTooltip'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    JobPreviewContentDataOutline,
    JobPreviewRightColumn,
    JobPreviewContentPieData,
    JobPreviewContentBarData,
    JobPreviewContentDataTooltip
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    environment: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      default: false
    },
    textCountMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /* 表示する要素の数に合わせて、「国認証」「その他の取り組み」へ付与するclassを調整する */
    // 横幅25%で表示されているエリアの数をカウント
    dataContentCount () {
      let count = 0
      if (this.environment.womanRate != null) count++
      if (this.environment.officerRate != null) count++
      if (this.environment.overtime != null) count++
      if (this.environment.ptoRate != null) count++
      if (this.environment.maternityRate != null) count++
      if (this.environment.lengthService != null) count++
      return count
    },
    // 「国認証」の右寄せ判定
    isCertificatePositionRight () {
      return this.dataContentCount === 1 || this.dataContentCount === 5
    },
    // 「その他の取り組み」の横幅調整判定
    isWomanActionPositionTop () {
      if (this.certificateCount > 0) {
        return this.dataContentCount === 0 || this.dataContentCount === 3 || this.dataContentCount === 4
      } else {
        return this.dataContentCount === 1 || this.dataContentCount === 2 || this.dataContentCount === 5 || this.dataContentCount === 6
      }
    },
    // 「その他の取り組み」の右寄せ判定
    isWomanActionPositionRight () {
      if (this.certificateCount === 0) {
        return this.dataContentCount === 1 || this.dataContentCount === 5
      }
      return false
    }
  }
}
</script>
